import { cloneDeep } from 'lodash';
import {
    OPEN_OVERLAY,
    CLOSE_OVERLAY,
} from 'framework/vuex/mutation-types';

import * as getters from './getters';
import * as actions from './actions';


const DEFAULT_STATE = {
    facet: 'base',
    transition: 'trs-overlay-fade',
    component: null,
    props: {},
};


/**
 * The mutations available in the module
 */
const mutations = {
    [OPEN_OVERLAY](state, payload) {
        state.overlay = Object.assign(cloneDeep(DEFAULT_STATE), payload, {
            isOpen: true,
        });
    },
    [CLOSE_OVERLAY](state, payload) {
        state.overlay = Object.assign(cloneDeep(DEFAULT_STATE), payload, {
            isOpen: false,
        });
    },
};

/**
 * The state of the module
 */
const state = {
    overlay: cloneDeep(DEFAULT_STATE),
};


export default {
    actions,
    state,
    getters,
    mutations,
};



// WEBPACK FOOTER //
// ./vehi-industriepfad/assets/src/js/app/framework/vuex/modules/overlay/index.js